import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Dropdown, Avatar, Button } from 'antd';
import { UserOutlined, LogoutOutlined, SettingOutlined } from '@ant-design/icons';

const UserMenu = () => {
  const { user, logout } = useAuth();

  if (!user) {
    return null;
  }

  const menuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: (
        <div style={{ padding: '8px 0' }}>
          <div style={{ fontWeight: 'bold', fontSize: '14px' }}>
            {user.name || 'User'}
          </div>
          <div style={{ fontSize: '12px', color: '#666' }}>
            {user.email}
          </div>
          <div style={{ fontSize: '11px', color: '#999', marginTop: '2px' }}>
            Role: {user.role || user.userType || 'User'}
          </div>
        </div>
      ),
    },
    {
      type: 'divider',
    },
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: 'Settings',
      onClick: () => {
        // TODO: Implement settings page
        console.log('Settings clicked');
      },
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
      onClick: logout,
      danger: true,
    },
  ];

  return (
    <Dropdown
      menu={{ items: menuItems }}
      placement="bottomRight"
      arrow
      trigger={['click']}
    >
      <Button
        type="text"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          height: '40px',
          padding: '4px 12px',
          borderRadius: '8px',
          border: '1px solid #d9d9d9',
          backgroundColor: '#fff',
        }}
      >
        <Avatar 
          size={32}
          icon={<UserOutlined />}
          style={{ 
            backgroundColor: '#1890ff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {user.name ? user.name.charAt(0).toUpperCase() : 'U'}
        </Avatar>
        <div style={{ 
          textAlign: 'left',
          lineHeight: '1.2',
          display: 'flex',
          flexDirection: 'column'
        }}>
          <span style={{ 
            fontSize: '14px', 
            fontWeight: '500',
            color: '#262626',
            maxWidth: '120px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}>
            {user.name || 'User'}
          </span>
          <span style={{ 
            fontSize: '12px', 
            color: '#8c8c8c',
            maxWidth: '120px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}>
            {user.role || user.userType || 'User'}
          </span>
        </div>
      </Button>
    </Dropdown>
  );
};

export default UserMenu;